module.exports = __webpack_public_path__ + "img/marmelaedchen-fahrrad_xs.4a834059.jpg";